var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['p-price', _vm.priceClass],style:([_vm.priceStyles])},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.product.price_html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }